import Refer from "views/Refer";
import InviteUser from "views/InviteUser";
import PaymentDiscovery from "components/custom/onboarding/subscription/PaymentDiscovery";
import PaymentDetails from "components/custom/onboarding/subscription/PaymentDetails";
import AmazonAdvertising from "components/custom/onboarding/AmazonAdvertising";
import AmazonSummary from "components/custom/onboarding/AmazonSummary";
import Billing from "views/Billing";
import Apps from "views/Apps";
import GooglePreferences from "views/integrations/GooglePreferences";
import Preferences from "views/Preferences";
import FetchTickets from "views/FetchTickets";
import { ReportRoutes } from "modules/perf_reports/routes";
import { QualityRoutes } from "modules/product_quality/routes";
import { PricingV2Routes } from "modules/pricingv2/routes";
import { PLRoutes } from "modules/pandl/routes";
import { WorkflowRoutes } from "modules/workflows/routes";
import { ReportCardRoutes } from "modules/reportcard/routes";
import { LiveRoutes } from "modules/live/routes";
import { CalendarRoutes } from "modules/events_calendar/routes";
import { SellerPerformanceRoutes } from "modules/seller_performance/routes";

import OnboardingSpApi from "components/custom/onboarding/OnboardingSpApi";
import AnalyticsView from "views/AnalyticsView";
import LaunchDashboard from "views/merchandise/LaunchDashboard";
import Search from "../views/Search";
import TrellisExtension from "views/chrome/TrellisExtension";
import NewLaunch from "views/merchandise/NewLaunch";
import LaunchDetails from "views/merchandise/LaunchDetails";
import MerchDashboard from "views/merchandise/Dashboard";
import PromotionsReport from "views/merchandise/PromotionsReport";
import MerchProduct from "views/merchandise/Product";
import MerchParent from "views/merchandise/Parent";
import MerchCoupons from "views/merchandise/Coupons";
import AdvertisingDashboard from "views/AdvertisingDashboard";
import AdvertisementDetails from "views/advertising/AdvertisementDetails";
import ApplicationsMenu from "views/ApplicationsMenu";
import AdvertisingOverview from "views/AdvertisingOverview";
import AgencyDashboard from "modules/organization/AgencyDashboard";
import ProgramList from "views/programs/ProgramList";
import ProgramCreate from "views/programs/ProgramCreate";
import ProgramEdit from "views/programs/ProgramEdit";
import AllCustomersDashboard from "views/merchandise/AllCustomersDashboard";
import { OnboardingRoutes } from "views/onboarding/routes/routes";
import VerifyEmail from "views/onboarding/components/VerifyEmail";
import WalmartSummary from "components/custom/onboarding/WalmartSummary";
import OrgAdvertisingConfiguration from "views/advertising/OrgAdvertisingConfiguration";
import AgencyManagementView from "views/AgencyManagementView";
import { DSPRoutes } from "views/dsp/routes";

import ShopperInsightsV2 from "views/ShopperInsightsV2";
import AMCDashboard from "views/amc/AMCDashboard";
import AMCReport from "views/amc/AMCReport";
import AMCReportsListing from "views/amc/AMCReportsListing";
import PathToPurchaseReport from "views/amc/pathToPurchase/PathToPurchaseReport";
import AMCAudienceDetails from "views/amc/audience/AMCAudienceDetails";
import SearchQueryPerformance from "views/SearchQueryPerformance";
import AudienceDashboard from "views/amc/audience/AudienceDashboard";
import AMCConfiguration from "views/amc/AMCConfiguration";
import { Connect } from "../modules/shopify/Connect";
import AdvertisingDashboardV2 from "views/AdvertisingDashboardV2";
import HarvestingRulesView from "views/HarvestingRulesView";
import { GoalsDashboard } from "../views/GoalsDashboard";
import { TclipRoutes } from "modules/tclip/routes";
import Trmnl from "modules/trmnl/Trmnl";

export type RouteDefinition =
  | {
      application: string;
      path: string;
      layout: string;
      exact?: boolean;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      component: React.ComponentType<any>;
      children?: never;
    }
  | {
      application: string;
      path: string;
      layout: string;
      exact?: boolean;
      component?: never;

      children: {
        path: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        component: React.ComponentType<any>;
        exact?: boolean;
      }[];
    };

const routes: RouteDefinition[] = [
  {
    path: "/dashboard",
    layout: "/user",
    component: MerchDashboard,
    application: "Merchandising",
    exact: true,
  },
  {
    path: "/agency/dashboard",
    layout: "/user",
    component: AgencyDashboard,
    application: "Merchandising",
    exact: true,
  },
  {
    path: "/staff/dashboard",
    layout: "/user",
    component: AllCustomersDashboard,
    application: "Merchandising",
    exact: true,
  },
  {
    path: "/advertising/dashboard",
    layout: "/user",
    component: AdvertisingDashboard,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/advertising/dashboardv2",
    layout: "/user",
    component: AdvertisingDashboardV2,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/advertising/dashboardv2/category/:id",
    layout: "/user",
    component: AdvertisingDashboardV2,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/advertising/dashboard/category/:id",
    layout: "/user",
    component: AdvertisingOverview,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/advertising/dashboard/ads/:id",
    layout: "/user",
    component: AdvertisementDetails,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/advertising/settings",
    layout: "/user",
    component: OrgAdvertisingConfiguration,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/chromeaccess",
    layout: "/user",
    component: TrellisExtension,
    application: "Admin",
  },
  {
    path: "/categorymanagement",
    layout: "/user",
    component: Search,
    application: "Product",
  },
  {
    path: "/plans",
    layout: "/onboard",
    component: PaymentDiscovery,
    application: "Admin",
  },
  {
    path: "/plans",
    layout: "/user",
    component: PaymentDiscovery,
    application: "Admin",
  },
  {
    path: "/payment",
    layout: "/onboard",
    component: PaymentDetails,
    application: "Admin",
  },
  {
    path: "/payment",
    layout: "/user",
    component: PaymentDetails,
    application: "Admin",
  },
  {
    path: "/applications",
    layout: "/user",
    component: ApplicationsMenu,
    application: "Admin",
  },
  {
    path: "/agencyusers",
    layout: "/user",
    component: AgencyManagementView,
    application: "Admin",
  },
  {
    path: "/amzadv",
    layout: "/onboard",
    component: AmazonAdvertising,
    application: "Advertising",
  },
  {
    path: "/amzadv",
    layout: "/user",
    component: AmazonAdvertising,
    application: "Advertising",
  },
  {
    path: "/amzspapi",
    layout: "/onboard",
    component: OnboardingSpApi,
    application: "Admin",
  },
  {
    path: "/amzsummary",
    layout: "/onboard",
    component: AmazonSummary,
    application: "Admin",
  },
  {
    path: "/amzsummary",
    layout: "/user",
    component: AmazonSummary,
    application: "Admin",
  },
  {
    path: "/walmartsummary",
    layout: "/user",
    component: WalmartSummary,
    application: "Admin",
  },
  {
    path: "/apps/shopify",
    layout: "/user",
    component: Connect,
    application: "Admin",
  },
  {
    path: "/apps",
    layout: "/user",
    component: Apps,
    application: "Admin",
  },
  {
    path: "/googleshopping",
    layout: "/user",
    component: GooglePreferences,
    application: "Admin",
  },
  {
    path: "/inviteuser",
    layout: "/user",
    component: InviteUser,
    application: "Admin",
  },
  {
    path: "/billing",
    layout: "/user",
    component: Billing,
    application: "Admin",
  },
  {
    path: "/preferences",
    layout: "/user",
    component: Preferences,
    application: "Admin",
  },
  {
    path: "/refer",
    layout: "/user",
    component: Refer,
    application: "Admin",
  },
  {
    path: "/shopperinsightsV2",
    layout: "/user",
    component: ShopperInsightsV2,
    application: "Reports",
  },
  {
    path: "/amc/shopperinsightsV2",
    layout: "/user",
    component: ShopperInsightsV2,
    application: "Reports",
  },
  {
    path: "/searchanalytics",
    layout: "/user",
    component: AnalyticsView,
    application: "Placement",
  },
  {
    path: "/merchandising",
    layout: "/user",
    application: "Merchandising",
    children: [
      {
        path: "/user/merchandising/dashboard",
        component: MerchDashboard,
        exact: true,
      },
      {
        path: "/user/merchandising/product/:product",
        component: MerchProduct,
        exact: true,
      },
      {
        path: "/user/merchandising/parent/:parentAsin",
        component: MerchParent,
        exact: true,
      },
      {
        path: "/user/merchandising/coupons",
        component: MerchCoupons,
        exact: true,
      },
      {
        path: "/user/merchandising/coupons/:coupon",
        component: MerchCoupons,
        exact: true,
      },
      {
        path: "/user/merchandising/category/:category/",
        component: MerchDashboard,
        exact: true,
      },
      {
        path: "/user/merchandising/promotions",
        component: PromotionsReport,
        exact: true,
      },
    ],
  },
  // TODO: Below will likely become part of merchandising children above
  {
    path: "/productlaunch",
    layout: "/user",
    application: "Product",
    children: [
      {
        path: "/user/productlaunch/launches/:id",
        component: LaunchDetails,
      },
      {
        path: "/user/productlaunch/new",
        exact: true,
        component: NewLaunch,
      },
      {
        path: "/user/productlaunch",
        exact: true,
        component: LaunchDashboard,
      },
    ],
  },
  {
    path: "/programs",
    layout: "/user",
    application: "Pricing",
    children: [
      {
        path: "/user/programs/edit/:id",
        component: ProgramEdit,
      },
      {
        path: "/user/programs/create",
        component: ProgramCreate,
      },
      {
        path: "/user/programs",
        exact: true,
        component: ProgramList,
      },
    ],
  },
  {
    path: "/advertising/programs",
    layout: "/user",
    application: "Advertising",
    children: [
      {
        path: "/user/advertising/programs/edit/:id",
        component: ProgramEdit,
      },
      {
        path: "/user/advertising/programs/create",
        component: ProgramCreate,
      },
      {
        path: "/user/advertising/programs",
        exact: true,
        component: ProgramList,
      },
    ],
  },
  {
    path: "/advertising/harvesters",
    layout: "/user",
    application: "Advertising",
    component: HarvestingRulesView,
    exact: true,
  },
  {
    path: "/verify",
    layout: "/user",
    component: VerifyEmail,
    application: "Admin",
    exact: true,
  },
  {
    path: "/amc/conversionchart",
    layout: "/user",
    component: PathToPurchaseReport,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/amc/conversionchart/reports",
    layout: "/user",
    component: AMCReportsListing,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/amc/dashboard",
    layout: "/user",
    component: AMCDashboard,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/amc/dashboard/reports/details/:id",
    layout: "/user",
    component: AMCReport,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/amc/dashboard/reports/:id",
    layout: "/user",
    component: AMCReportsListing,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/amc/dashboard/audiences/:id",
    layout: "/user",
    component: AMCAudienceDetails,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/amc/configuration",
    layout: "/user",
    component: AMCConfiguration,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/audience/dashboard",
    layout: "/user",
    component: AudienceDashboard,
    application: "Advertising",
    exact: true,
  },
  {
    path: "/searchqueryperformance",
    layout: "/user",
    application: "Reports",
    children: [
      {
        path: "/user/searchqueryperformance",
        exact: true,
        component: SearchQueryPerformance,
      },
      {
        path: "/user/searchqueryperformance/:id",
        component: SearchQueryPerformance,
      },
    ],
  },
  {
    path: "/tickets",
    layout: "/user",
    component: FetchTickets,
    application: "Admin",
  },
  {
    path: "/trmnl",
    layout: "/user",
    component: Trmnl,
    application: "Admin",
  },
  {
    path: "/goals",
    layout: "/user",
    component: GoalsDashboard,
    application: "Merchandising",
  },
  {
    path: "/",
    layout: "/user",
    component: MerchDashboard,
    application: "Merchandising",
  },
];

let allRoutes: RouteDefinition[] = [];
allRoutes = allRoutes.concat(ReportRoutes);
allRoutes = allRoutes.concat(QualityRoutes);
allRoutes = allRoutes.concat(PricingV2Routes);
allRoutes = allRoutes.concat(PLRoutes);
allRoutes = allRoutes.concat(WorkflowRoutes);
allRoutes = allRoutes.concat(ReportCardRoutes);
allRoutes = allRoutes.concat(SellerPerformanceRoutes);
allRoutes = allRoutes.concat(OnboardingRoutes);
allRoutes = allRoutes.concat(LiveRoutes);
allRoutes = allRoutes.concat(CalendarRoutes);
allRoutes = allRoutes.concat(DSPRoutes);
allRoutes = allRoutes.concat(TclipRoutes);
allRoutes = allRoutes.concat(routes);

export default allRoutes;
